import OverlayBase from "../overlay/OverlayBase";
import {useData} from "../../../hooks/useData";
import {useLocalStorage} from "../../../hooks/useLocalStorage";
import {GetPlayerNotesResponse, PlayerLite, PlayerNote} from "../interfaces";
import {relativeDate} from "../../../util/timeConverter";
import SvgLoader from "../../../svg/SvgLoader";
import React, {useRef, useState} from "react";
import {doFetch} from "../../../util/fetch";

export default function PlayerNotesOverlay({player, hide} : {player: PlayerLite, hide: () => void}) {

    const [serverId, ] = useLocalStorage("serverId")
    const [newNoteId, setNewNoteId] = useState<string>("")

    const data = useData<GetPlayerNotesResponse>(`/api/client/players/notes?serverId=${serverId}&steamId=${player.steamId}&n=${newNoteId}`)

    return (
        <OverlayBase hide={hide}>
            {data.isLoading && (
                <div className="flex flex-col items-center">
                    <SvgLoader/>
                    <p className="mt-4 text-white text-lg font-semibold tracking-wide">Loading...</p>
                </div>
            )}
            {data.data && <NotesOverlay notes={data.data.notes} player={player} />}
            {data.error && <p className="text-red-500">Failed to load data: {data.error}</p>}
        </OverlayBase>
    )

    function NotesOverlay({notes, player}: {notes: PlayerNote[], player: PlayerLite}){
        const newNoteRef = useRef<HTMLTextAreaElement>(null)

        const saveNote = () => {
            if (!newNoteRef.current) {
                return;
            }

            doFetch<PostNoteResponse>(`/api/client/players/notes?serverId=${serverId}`, {
                method: "POST",
                body: JSON.stringify({
                    steamId: player.steamId,
                    content: newNoteRef.current.value
                }),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(r => {
                if (r.ok && r.data) {
                    if (newNoteRef.current){
                        newNoteRef.current.value = ""
                    }
                    setNewNoteId(r.data.id)
                }
            })
        }

        const deleteNote = (id: string) => {

            doFetch<PostNoteResponse>(`/api/client/players/notes?serverId=${serverId}&noteId=${id}`, {
                method: "DELETE"
            }).then(r => {
                if (r.ok) {
                    setNewNoteId('-' + id)
                }
            })
        }

        return (<div>
            <div className="flex flex-row align-top">
                <div className="flex flex-col select-text">
                    <h3 className="text-xl font-bold">{notes.length} Notes for {player.displayName}</h3>
                </div>
            </div>
            <div className="flow-root mt-2">
                <textarea className="rounded-md border-neutral-800 border p-2 w-full bg-neutral-600"
                          ref={newNoteRef} placeholder="Click to add note"></textarea>
                    <button className="bg-primary hover:bg-primary-hover rounded-md px-2 py-1 float-right" onClick={saveNote}>Save</button>
            </div>
            <div className="space-y-2 mt-3">
                {notes.map(n =>
                    <div key={n.id}>
                        <button className="bg-red-500 hover:bg-red-600 rounded-md px-1 float-right" onClick={() => deleteNote(n.id)}>Delete</button>
                        <div className="bg-neutral-600 rounded-md p-2">{n.content.split('\n').map((x, i) => <p key={i}>{x}</p>)}</div>
                        <span className="text-neutral-200 ms-2 text-sm" >{n.author ?? <i>Unknown User</i>} at {relativeDate(n.created)}</span>
                    </div>
                )}
            </div>
        </div>)
    }
}

interface PostNoteResponse{
    id: string
}
